import { useTranslation } from 'react-i18next';

import {
  Loader,
  Typography,
  TYPOGRAPHY_SIZE,
  ButtonsWrapper,
  ICONS,
} from '@thinknet-gmbh/platform-common-ui';
import {
  PERMISSION_ACTIONS,
  PLATFORM_PERMISSIONS,
  EmployeeContractTypesEnum,
} from '@thinknet-gmbh/platform-common';

import { useRouteQuery } from 'src/common/helpers';
import { useGetWorkingConditions } from 'src/hooks/working-conditions/get-paginated-working-conditions.hook';

import PermissionCheck from '../../permission-check';
import { DropdownButton } from '../components/dropdown-button';
import WorkingConditionsTable from './working-conditions-table/working-conditions-table.component';

import { ConditionTopBarWrapper, ViewContainer } from './working-conditions-list.styles';

const WorkingConditionsList = ({
  onClickEdit,
  onClickCreate,
  createdBy,
}: {
  onClickEdit: (data: any) => void;
  onClickCreate: (type: string) => void;
  createdBy: string;
}) => {
  const { t } = useTranslation(['common', 'employee', 'settings']);

  const query = useRouteQuery();
  const _id: string = query.get('id') || '';

  const { collection, loading } = useGetWorkingConditions(_id);

  if (loading) {
    return <Loader />;
  }

  return (
    <ViewContainer>
      <ConditionTopBarWrapper>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {t('employee:labels.workingConditions')}
        </Typography>
        <ButtonsWrapper>
          <PermissionCheck
            permission={PLATFORM_PERMISSIONS.memberManagement}
            action={PERMISSION_ACTIONS.update}
            createdBy={createdBy}
          >
            <DropdownButton
              title={t('employee:buttons.newWorkingConditions')}
              icon={ICONS.plus}
              listItem={[
                {
                  key: 'NOT_FIXED ',
                  label: t('employee:workingConditions.labels.contractType.notFixed'),
                  handler: () => {
                    onClickCreate(EmployeeContractTypesEnum.NOT_FIXED);
                  },
                },
                {
                  key: 'FIXED ',
                  label: t('employee:workingConditions.labels.contractType.fixed'),
                  handler: () => {
                    onClickCreate(EmployeeContractTypesEnum.FIXED);
                  },
                },
              ]}
            />
          </PermissionCheck>
        </ButtonsWrapper>
      </ConditionTopBarWrapper>
      <WorkingConditionsTable collection={collection} loading={loading} onClickEdit={onClickEdit} />
    </ViewContainer>
  );
};

export default WorkingConditionsList;
